export const RESET_TRANSLATION_MISSING_REQUEST = "RESET_TRANSLATION_MISSING_REQUEST";
export const SET_TRANSLATION_MISSING_REQUEST = "SET_TRANSLATION_MISSING_REQUEST";
